import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {candidatAccepted} from "../../../../../shared/utils/data/shared.data";
import {CandidatesApplied} from "../../../../../models/Mission";
import {MissionService} from "../../../../../services/mission.service";
import {FlagService} from "../../../../../shared/services/flag.service";
import {environment} from "../../../../../../environments/environment";
import {DetailsComponent} from "../../../candidatures/details/details.component";
import {MatDialog} from "@angular/material/dialog";
import {CandidatStatusOnMission, FlagType} from "../../../../../shared/utils/enums";
import {CustomDialogComponent} from "../../../../../shared/custom-dialog/custom-dialog.component";
import {EtablissementData} from "../../../../../shared/utils/data/etablissments-data";

@Component({
  selector: 'app-mission-candidatures',
  templateUrl: './mission-candidatures.component.html',
  styleUrl: './mission-candidatures.component.scss'
})
export class MissionCandidaturesComponent implements OnInit{
  @Input() candidatesApplied : CandidatesApplied[] = []
  @Input() missionId : number
  @Output() closeSlider: EventEmitter<any> = new EventEmitter<any>()
  loading = false;
  @Input() expired = false;
  candidatesAccepted: CandidatesApplied[] =[]
  candidatesNotAccepted: CandidatesApplied[] =[]

  constructor(private missionService: MissionService, private flag: FlagService, private dialog: MatDialog){

  }

  ngOnInit(): void {
    //Called after the constructor, initializing input properties, and the first call to ngOnChanges.
    //Add 'implements OnInit' to the class.
    this.candidatesAccepted = this.candidatesApplied.filter(c => candidatAccepted.includes(c.statusOfCandidatOnMission))
    this.candidatesNotAccepted = this.candidatesApplied.filter(c => !candidatAccepted.includes(c.statusOfCandidatOnMission))
  }


  acceptCancelRequest(candidate: CandidatesApplied){
    const dialog = this.dialog.open(CustomDialogComponent, {
      data: {
        title: EtablissementData.mission.cancelRequest.title,
        description: EtablissementData.mission.cancelRequest.description,
        primaryLabel: EtablissementData.mission.cancelRequest.primaryButton,
        secondaryLabel: EtablissementData.mission.cancelRequest.secondButton,
      },
      maxWidth: '464px',
      autoFocus: false,
    });
    dialog.afterClosed().subscribe((value) => {
      if (value) {
        this.missionService.acceptCancelRequest(candidate.candidatId, this.missionId).subscribe({
            next: () => {
                this.flag.displayFlag('Annulation de la candidature acceptée !', FlagType.success)
              this.closeSlider.emit(true)
            }
        })
      }
    })
  }

  updateApplicationStatus(candidate: CandidatesApplied, status = this.CandidatStatusOnMission.ACCEPTED) {
    const body = {
      candidatId: candidate.candidatId,
      missionId: this.missionId,
      status
    }
    this.loading = true;
    this.missionService.updateCandidateStatus(body).subscribe({
      next: (res) => {
        this.loading = false;
        candidate.statusOfCandidatOnMission = res.status;
        this.flag.displayFlag(`${candidate.candidateName} a été accepté pour cette mission`, FlagType.success)
        this.closeSlider.emit(true)
      },
      error: () => {
        this.loading = false;
        this.flag.displayFlag(`Veuillez contacter l'équipe Collary`, FlagType.error)
      },
    })
  }

  openDetailCandidate = (id: any) => {
    this.dialog.open(DetailsComponent, {
      width: '666px',
      height: '100vh',
      position: { right: '0' },
      backdropClass: 'bg-transparent',
      data: {
        candidature: {candidatId: id}
      },
      // animation: { to: "left" }
    });
  };

  protected readonly CandidatStatusOnMission = CandidatStatusOnMission;
    protected readonly environment = environment;

}
